import * as React from 'react';

import { Responsive } from '@cian/ui-kit';

import { DesktopViewContainer, MobileViewContainer } from './views';
import { NotificatorContainer } from '../NotificatorContainer';
import { useSendBlocksExists } from '../../utils/teaser/useSendBlocksExists';
import { useSelector } from 'react-redux';
import { selectDealType, selectIsMyHome } from '../../selectors/page';
import { selectEstimationByDealType } from '../../selectors/estimation';
import { ErrorScreen } from '../../components/ErrorScreen';
import { MyHomeDesktopView, MyHomeMobileView } from './views/MyHome';
import { useCustomPopHistory } from '../CalculatorPageContainer/utils';

export const SuburbanPageContainer: React.FC = () => {
  const dealType = useSelector(selectDealType);
  const estimation = useSelector(selectEstimationByDealType(dealType));

  useCustomPopHistory();
  const sendBlocksExists = useSendBlocksExists();

  const isMyHome = useSelector(selectIsMyHome);

  const DesktopView = isMyHome ? MyHomeDesktopView : DesktopViewContainer;
  const MobileView = isMyHome ? MyHomeMobileView : MobileViewContainer;

  React.useEffect(() => {
    sendBlocksExists();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (estimation.isError) {
    return <ErrorScreen />;
  }

  return (
    <>
      <Responsive desktop>
        <DesktopView />
      </Responsive>
      <Responsive phone tablet>
        <MobileView />
      </Responsive>

      <NotificatorContainer />
    </>
  );
};

SuburbanPageContainer.displayName = 'SuburbanPageContainer';
